// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-article----ArticleCard-module---root---3J8RO","title":"src-components-article----ArticleCard-module---title---2Ut4I","description":"src-components-article----ArticleCard-module---description---hghMl","date":"src-components-article----ArticleCard-module---date---2uRmM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/article/ArticleCard.module.css
// module id = 625
// module chunks = 174759553322802